// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-subscription{padding-top:60px}.plan-subscription .sendbee-logo{height:46px}.plan-subscription h2{font-size:26px;font-weight:600;color:#141c20;margin:5px 0;text-transform:capitalize}.plan-subscription .description{font-size:15px;font-weight:400;color:#8e949b;text-transform:capitalize}.plan-subscription .message{font-size:18px;font-weight:600;color:#b1b8c4}.plan-subscription label{color:#7a7f89;margin-bottom:.5rem;font-size:12px;text-transform:capitalize;font-weight:600}", ""]);
// Exports
module.exports = exports;
